<template>
    <b-modal v-model="visible" :modal-class="modalClass"  hide-footer v-bind:title="title">
        <b-form @submit="onSubmit" >
            <p>{{message}}</p>
            <label v-if="options.label" for="text-password">{{options.label}}</label>
            <b-form-input v-bind:type="options.type" id="text-input" required trim v-model="value"></b-form-input>
            <b-form-text v-if="options.help" id="password-help-block">{{options.help}}</b-form-text>
            <div class="modal-footer">
                <b-button type="button" @click="onCancel" variant="light">{{options.btnNo}}</b-button>     
                <b-button type="submit"  variant="primary">{{options.btnYes}}</b-button> 
            </div>    
        </b-form>    
    </b-modal>
</template>

<script>
    export default {
        data: function () {
            return {
                message: '',
                title: '',
                success: null,
                cancel: null,
                modalClass: 'bs-modal-prompt colored-header',
                options: {
                    help: "",
                    label: "",
                    type: "text",
                    value: '',
                    btnYes: 'Ok',
                    btnNo: 'Abbrechen',
                    modalClass: ''
                },
                visible: false,
                value: ''
            };
        },
        methods: {
            show: async function (message, title, options = {}, success = null, cancel = null) {
                this.visible = true;
                await this.$nextTick();
                this.title = title;
                this.message = message;
                this.success = success;
                this.cancel = cancel;
                this.options = {...this.options, ...options};
                this.value = this.options.value;
                this.modalClass = this.modalClass + ' ' + this.options.modalClass;
            },
            onSubmit: function (event) {
                event.preventDefault();
                this.visible = false;
                if (this.success) {
                    this.success(this.value);
                }
            },
            onCancel: function (event) {
                event.preventDefault();
                this.visible = false;
                if (this.cancel) {
                    this.cancel();
                }
            }
        }
    }
</script>

<style lang="scss">
    .bs-modal-prompt{
      .modal-footer{
        padding-bottom: 0;
        margin: 1rem -1rem 0 -1rem;
        flex-wrap: nowrap;
        flex-direction: column-reverse;
        .btn{
          width:100%;
        }
        @media (min-width: 480px){
          flex-direction: row;
        }
      }


    }
</style>    
